export default {
    text_1: "Statistiky",
    text_2: "Zajímají tě čísla? Na tomto místě najdeš to nejdůležitější.",
    text_2_free: "Všechny statistiky jsou vygenerovány náhodnými čísly, protože nejsi platící uživatel.",
    text_3: "Základní údaje",
    text_4: "Hodnota nabídek tento měsíc",
    text_5: "Celková hodnota nabídek",
    text_6: "Počet klientů",
    text_7: "Hodnota tvých nabídek",
    text_8: "Počet tvých nabídek",
    text_9: "Moji uživatelé",
    text_10: "Využívají DOFFERO i tvoji zaměstnanci nebo kolegové? Zde uvidíš statistiky svých uživatelů. Tyto statistiky vidíš jen ty.",
    text_11: "Aktuálně nemáš přidány žádné uživatele.",
    text_12: "Přidat uživatele",
    text_13: "počet nabídek",
    text_14: "hodnota celkem",
    text_15: "Jméno",
    text_16: "Celkem:",
    text_17: "Průměrná hodnota nabídky",
    text_18: "Celková",
    text_19: "Podle stavů",
    text_20: "Graf je možné filtrovat podle stavů nabídek, stačí kliknout na konkrétní stav v legendě grafu.",

    january: "Leden",
    february: "Únor",
    march: "Březen",
    april: "Duben",
    may: "Květen",
    june: "Červen",
    july: "Červenec",
    august: "Srpen",
    september: "Září",
    october: "Říjen",
    november: "Listopad",
    december: "Prosinec",

    graph_text1: " nabídek",
    graph_text2: " nabídka",
    graph_text3: " nabídky",
    graph_text4: " uživatel",
    graph_text5: " uživatelů",

    graph_text6: " emailů",
    graph_text7: " email",
    graph_text8: " emaily",

}
